export function LogInLeft() {
    return (
        <div className="log-in-left-side">
            <img src="https://app.immerse.online/_next/image?url=%2FLoginBg.png&w=1920&q=100"
                alt="sfondo"
                className="body-bg" />
            <div className="log-in-top-bg">
                <img src="https://app.immerse.online/_next/image?url=%2FLoginConfetti.png&w=1920&q=100"
                    alt=""
                    className="log-in-bg-img" />
                <p>Welcome Back</p>
            </div>
            <img src="https://app.immerse.online/_next/image?url=%2FLoginAvatars.png&w=2048&q=100" alt="" className="log-in-people-img" />
        </div>
    )
}